import { render } from "./RoyaltiesCalculator.vue?vue&type=template&id=7489fd3c&scoped=true"
import script from "./RoyaltiesCalculator.vue?vue&type=script&lang=js"
export * from "./RoyaltiesCalculator.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7489fd3c"]])

export default __exports__